/* eslint-disable */
import Home from "Pages/Home/Home";
import Agenda from "Pages/Agenda/Agenda";
import Partners from "Pages/Partners/Partners";
import Speakers from "Pages/Speakers/Speakers";
import Networks from "Pages/Network/Networks";
import Community from "Pages/Community/Community";
import MyMeetings from "Pages/MyMeetings/MyMeetings";
import Report from "Pages/Report/Report";
import Logout from "Pages/Auth/Logout";
import EventList from "../Pages/Events/EventList/EventList";
import EventDetails from "Pages/Events/EventDetails/EventDetails";
import MyAccount from "Pages/MyAccount/MyAccount";
import MyInvites from "Pages/MyInvites/MyInvites";
import UserDetails from "Pages/UserDetails/UserDetails";

/*======= public route start =======*/
const publicRoutes = [
  { path: "/", component: Home },
  { path: "/events", component: EventList },
  { path: "/event/details/:id", component: EventDetails },
  { path: "/agenda", component: Agenda },
  { path: "/speakers", component: Speakers },
  { path: "/partners", component: Partners },
  { path: "/community", component: Community },
  { path: "/networks", component: Networks },
  { path: "/user/details/:id", component: UserDetails },
];
/*======= public route end =======*/

/*======= protected route start =======*/
const protectedRoutes = [
  /* ========== logout start ======== */
  { path: "/report", component: Report },
  { path: "/mymeeting", component: MyMeetings },
  { path: "/myaccount", component: MyAccount },
  { path: "/myinvites", component: MyInvites },
  { path: "/logout", component: Logout },
];
/*======= protected route end =======*/

export { publicRoutes, protectedRoutes };
